import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  settingRow: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(1),
  },
}));
